import { useEffect, useRef } from 'react';

export const useMutationObserver = (
  elementRef: HTMLElement,
  callback: MutationCallback,
  config: MutationObserverInit = {
    attributes: true,
    childList: true,
    subtree: true,
  },
) => {
  const observer = useRef<MutationObserver>();

  useEffect(() => {
    if (observer.current) {
      observer.current.disconnect();
    }

    if (elementRef) {
      observer.current = new MutationObserver(callback);
      observer.current.observe(elementRef, config);
    }
  }, [callback, elementRef, config]);

  useEffect(() => {
    return () => {
      if (observer.current) {
        observer.current.disconnect();
      }
    };
  }, []);
};
